import { OilBlockDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadOilBlock = createAction('[OilBlock] Load OilBlock');

export const loadOilBlockSuccess = createAction(
  '[OilBlock] Load OilBlock Success',
  props<{ oilBlock: OilBlockDto[] }>()
);

export const loadOilBlockFailure = createAction(
  '[OilBlock] Load OilBlock Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addOilBlock = createAction(
  '[OilBlock] Add OilBlock',
  props<{ newOilBlock: OilBlockDto[] }>()
);

export const addOilBlockSuccess = createAction(
  '[OilBlock] Add OilBlock Success',
  props<{ newOilBlock: OilBlockDto[] }>()
);

export const addOilBlockFailure = createAction(
  '[OilBlock] Add OilBlock Failure',
  props<{ error: any }>()
);

/**
 * Update OilBlock Collection Actions
 */
export const updateOilBlock = createAction(
  '[OilBlock] Update OilBlock',
  props<{ updateOilBlock: OilBlockDto[] }>()
);

export const updateOilBlockSuccess = createAction(
  '[OilBlock] Update OilBlock Success',
  props<{ updateOilBlock: OilBlockDto[] }>()
);

export const updateOilBlockFailure = createAction(
  '[OilBlock] Update OilBlock Failure',
  props<{ error: any }>()
);

/**
 * Remove OilBlock Collection Actions
 */
export const removeOilBlock = createAction(
  '[OilBlock] Remove OilBlock',
  props<{ ids: string[] }>()
);

export const removeOilBlockSuccess = createAction(
  '[OilBlock] Remove OilBlock Success',
  props<{ ids: string[] }>()
);

export const removeOilBlockFailure = createAction(
  '[OilBlock] Remove OilBlock Failure',
  props<{ error: any }>()
);
